import { getRenderingEngine } from "@cornerstonejs/core";

/**
 * Resizes all viewports managed by a specific rendering engine
 * @param renderingEngineId The ID of the rendering engine
 */
export function resizeViewports(renderingEngineId = "myRenderingEngine"): void {
  try {
    const renderingEngine = getRenderingEngine(renderingEngineId);
    
    if (renderingEngine) {
      console.log("Resizing viewports for rendering engine:", renderingEngineId);
      renderingEngine.resize(true);
    } else {
      console.warn("Rendering engine not found for resize:", renderingEngineId);
    }
  } catch (error) {
    console.error("Error while resizing viewports:", error);
  }
}

/**
 * Creates a debounced function that delays invoking func until after wait milliseconds
 * have elapsed since the last time the debounced function was invoked.
 */
export function debounce<T extends (...args: any[]) => any>(
  func: T,
  wait = 100
): (...args: Parameters<T>) => void {
  let timeout: number | undefined;
  
  return function(...args: Parameters<T>): void {
    clearTimeout(timeout);
    timeout = window.setTimeout(() => func(...args), wait);
  };
}

/**
 * Creates a debounced resize handler for Cornerstone viewports
 * @param renderingEngineId The ID of the rendering engine
 * @param wait Debounce wait time in milliseconds
 */
export function createResizeHandler(
  renderingEngineId = "myRenderingEngine",
  wait = 100
): () => void {
  return debounce(() => resizeViewports(renderingEngineId), wait);
}